import { render, staticRenderFns } from "./HiaCodeInput.vue?vue&type=template&id=5230b7aa&scoped=true&"
import script from "./HiaCodeInput.vue?vue&type=script&lang=js&"
export * from "./HiaCodeInput.vue?vue&type=script&lang=js&"
import style0 from "./HiaCodeInput.vue?vue&type=style&index=0&id=5230b7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5230b7aa",
  null
  
)

export default component.exports